export default {
  state: {
    partNumber: '',
    productInfoId: '',
    productLegalText: '',
    productMarketingSummary: '',
    productName: '',
    productVariation: '',
    shippingDisclaimer: '',
    showPartNumber: false,
    showProductVariationName: false,
    showCompatibleDevicesTab: false,
    productHeaderDetails: '',
    productKicker: null,
    productAvailability: '',
    sellable: false,
    productEmsList: [],
    filterDropdownList: [],
  },
  getters: {
    getPartNumber(state) {
      return state.partNumber;
    },
    getProductInfoId(state) {
      return state.productId;
    },
    getProductLegalText(state) {
      return state.productLegalText;
    },
    getShowProductLegalText(state, getters) {
      return !!getters.getProductLegalText.length;
    },
    getProductMarketingSummary(state) {
      return state.productMarketingSummary;
    },
    getShowProductMarketingSummary(state, getters) {
      return !!getters.getProductMarketingSummary.length;
    },
    getProductName(state) {
      return state.productName;
    },
    getProductVariation(state) {
      return state.productVariation;
    },
    getShippingDisclaimer(state) {
      return state.shippingDisclaimer;
    },
    getShowShippingDisclaimer(state, getters) {
      return !!getters.getShippingDisclaimer.length;
    },
    getProductHeaderDetails(state) {
      return state.productHeaderDetails;
    },
    getShowProductHeaderDetails(state, getters) {
      return !!getters.getProductHeaderDetails.length;
    },
    getShowProductName(state, getters) {
      return !!getters.getProductName;
    },
    getShowPartNumber(state) {
      return state.showPartNumber;
    },
    getShowProductVariationName(state) {
      return state.showProductVariationName;
    },
    getShowCompatibleDevicesTab(state) {
      return state.showCompatibleDevicesTab;
    },
    getProductKicker(state) {
      return state.productKicker;
    },
    getShowProductKicker(state, getters) {
      return !!getters.getProductKicker;
    },
    getProductKickerContent(state, getters) {
      const productKicker = getters.getProductKicker;
      return productKicker ? productKicker.kicker : '';
    },
    getProductKickerText(state, getters) {
      const productKicker = getters.getProductKicker;
      return productKicker && productKicker.text ? productKicker.text : '';
    },
    getProductAvailability(state) {
      return state.productAvailability;
    },
    getShowProductAvailability(state, getters) {
      return !!getters.getProductAvailability.length;
    },
    getSellable(state) {
      return state.sellable;
    },
    getProductEmsList(state) {
      return state.productEmsList;
    },
    getFilterDropdownList(state) {
      return state.filterDropdownList;
    },
    getFilterDropdownSelected(state) {
      // Return the item that is selected or the first one in the list if nothing is selected
      return state.filterDropdownList.find((option) => option.selected)
             || state.filterDropdownList[0]
             || {};
    },
  },
  mutations: {
    setPartNumber(state, payload) {
      state.partNumber = payload;
    },
    setProductInfoId(state, payload) {
      state.productId = payload;
    },
    setProductMarketingSummary(state, payload) {
      state.productMarketingSummary = payload || '';
    },
    setProductName(state, payload) {
      state.productName = payload;
    },
    setProductVariation(state, payload) {
      state.productVariation = payload;
    },
    setShippingDisclaimer(state, payload) {
      state.shippingDisclaimer = payload || '';
    },
    setProductHeaderDetails(state, payload) {
      state.productHeaderDetails = payload || '';
    },
    setProductLegalText(state, payload) {
      state.productLegalText = payload || '';
    },
    setShowPartNumber(state, payload) {
      state.showPartNumber = payload;
    },
    setShowProductVariationName(state, payload) {
      state.showProductVariationName = payload;
    },
    setShowCompatibleDevicesTab(state, payload) {
      state.showCompatibleDevicesTab = !!payload;
    },
    setProductKicker(state, payload) {
      state.productKicker = payload;
    },
    setProductAvailability(state, payload) {
      state.productAvailability = payload || '';
    },
    setSellable(state, payload) {
      state.sellable = payload;
    },
    setProductEmsList(state, payload) {
      state.productEmsList = payload;
    },
    setFilterDropdownList(state, payload) {
      state.filterDropdownList = payload;
    },
    setFilterDropdownSelected(state, payload) {
      state.filterDropdownList = state.filterDropdownList.map((option) => {
        option.selected = payload === option.value;
        return option;
      });
    },
  },
  actions: {
    setProductInfo({ commit, dispatch }, payload) {
      const {
        partNumber,
        productId,
        productLegalText,
        promoBanner,
        productMarketingSummary,
        productName,
        productVariation,
        shippingDisclaimer,
        showPartNumber,
        showProductVariationName,
        showCompatibleDevicesTab,
        productHeaderDetails,
        productKicker,
        productAvailability,
        sellable,
        seo,
      } = payload;

      commit('setPartNumber', partNumber);
      commit('setProductId', productId);
      commit('setProductLegalText', productLegalText);
      commit('setProductMarketingSummary', productMarketingSummary);
      commit('setProductName', productName);
      commit('setProductVariation', productVariation);
      commit('setShippingDisclaimer', shippingDisclaimer);
      commit('setShowPartNumber', showPartNumber);
      commit('setShowProductVariationName', showProductVariationName);
      commit('setShowCompatibleDevicesTab', showCompatibleDevicesTab);
      commit('setProductHeaderDetails', productHeaderDetails);
      commit('setProductKicker', productKicker);
      commit('setProductAvailability', productAvailability);
      commit('setSellable', sellable);
      dispatch('setPromoBanner', promoBanner);
      dispatch('setSeoTitle', seo.title);
    },
    setProductOptionsList({ commit }, payload) {
      const { productEmsList, filterDropdownList } = payload;
      commit('setProductEmsList', productEmsList);
      commit('setFilterDropdownList', filterDropdownList);
    },
    setFilterDropdownSelected({ commit }, payload) {
      commit('setFilterDropdownSelected', payload);
    },
    setShowCompatibleDevicesTab({ commit }, payload) {
      commit('setShowCompatibleDevicesTab', payload);
    },
    setSeoTitle(context, title) {
      // use native dom parser to parse special characters in title string
      const parser = new DOMParser();
      const dom = parser.parseFromString(title, 'text/html');

      // Prevent setting the title to null if we don;t have a seo title
      if (title && dom.body.textContent) {
        document.title = dom.body.textContent;
      }
    },
  },
};
